// extracted by mini-css-extract-plugin
export var chevron = "_bx-4";
export var chevronExpanded = "_bx-5";
export var row = "_bx-0";
export var rowBody = "_bx-6";
export var rowDescription = "_bx-7";
export var rowHeader = "_bx-1";
export var rowTitle = "_bx-2";
export var rowTitleComplete = "_bx-3";